import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { VendorCompany } from "~/models/VendorCompany";

const paths = {
	index: "/vendors/vendor_partner_candidates"
} as const;

type TIndex = (name: string) => SwrReturnType<VendorCompany[]>;
type ReturnType = {
	index: TIndex;
};

export const useVendorPartnerCandidates = (): ReturnType => {
	const index: TIndex = (name: string) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error, isLoading } = useSWR<VendorCompany[]>({
			params: { name },
			url: paths.index
		});
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate
		};
	};
	return { index };
};
